var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './Facebook.module.scss';
import api from '../../../axios';
import { fetchPreferences } from '../../../Redux/slices/Preferences/preferences';
import Cookies from 'universal-cookie';
import { userConstants } from '../../../Redux/_reducers';
import { getLibraries } from '../../../Redux/_actions';
import { Button, Tooltip } from 'antd';
import { FacebookIcon } from '../../../helpers/icons';
import { useTypeDispatch } from '../../../hooks/useTypeHooks';
var Facebook = function () {
    var dispatch = useTypeDispatch();
    var cookies = new Cookies();
    var isRussUser = navigator.languages.includes('ru');
    var fbRequest = function (response) {
        if (response.status === 'connected') {
            FB.api("/me", { fields: 'email' }, function (res) {
                var _a;
                var accessToken = JSON.stringify({
                    access_token: (_a = response.authResponse) === null || _a === void 0 ? void 0 : _a.accessToken,
                    email: res.email,
                });
                api.facebookLogin(accessToken, { 'Content-Type': 'application/json' }).then(function (user) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                dispatch({ type: userConstants.LOGIN_SUCCESS, user: user }); // set user
                                dispatch(getLibraries()); // update libraries
                                return [4 /*yield*/, dispatch(fetchPreferences())];
                            case 1:
                                _a.sent();
                                cookies.set('isAuthorization', 'true', { path: '/', domain: 'gtobase.com' });
                                return [2 /*return*/];
                        }
                    });
                }); });
            });
        }
    };
    var facebookLogin = function () {
        try {
            FB.login(fbRequest, { scope: 'public_profile, email', return_scopes: true });
        }
        catch (error) {
            console.log(error);
        }
    };
    return (_jsx(_Fragment, { children: isRussUser ? (_jsx(Tooltip, __assign({ title: '\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 VPN \u0434\u043B\u044F \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0447\u0435\u0440\u0435\u0437 Facebook', mouseLeaveDelay: 0, destroyTooltipOnHide: true }, { children: _jsx(Button, __assign({ className: styles.facebookContainer, onClick: facebookLogin, icon: _jsx(FacebookIcon, {}) }, { children: "Sign in with Facebook" })) }))) : (_jsx(Button, __assign({ className: styles.facebookContainer, onClick: facebookLogin, icon: _jsx(FacebookIcon, {}) }, { children: "Sign in with Facebook" }))) }));
};
export default Facebook;
